module.exports = __webpack_public_path__ + "img/infoq.9fbf2038.png";